(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Mobile FILTER must survive a slow or failed custom-element hydration.
  // The normal KERVELAN mobile runtime takes over once it reports ready.
  document.addEventListener('click', (event) => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    if (window.__KervelanMobileCollectionReferenceReady === true) return;

    const target = event.target;
    if (!(target instanceof Element)) return;

    const filterTrigger = target.closest('.kv-mobile-collection-controls__filter');
    if (!(filterTrigger instanceof HTMLButtonElement)) return;

    const collection = filterTrigger.closest('collection-component.kervelan-collection');
    const drawer = collection?.querySelector('#filters-drawer');
    const panel = drawer?.querySelector('.theme-drawer__dialog');

    if (!(drawer instanceof HTMLElement) || !(panel instanceof HTMLDialogElement)) return;

    // If ThemeDrawer is already upgraded, let its declarative on:click action
    // handle the event. This fallback is only for the pre-hydration gap.
    if (typeof drawer.open === 'function') return;

    event.preventDefault();
    event.stopPropagation();

    if (!panel.open) {
      try {
        panel.showModal();
        drawer.setAttribute('open', '');
      } catch (_error) {
        // A subsequent tap can retry after the custom element hydrates.
      }
    }
  }, true);

  document.addEventListener('click', (event) => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const target = event.target;
    if (!(target instanceof Element)) return;

    const closeTrigger = target.closest('#filters-drawer .theme-drawer__close-button');
    if (!(closeTrigger instanceof HTMLElement)) return;

    const drawer = closeTrigger.closest('#filters-drawer');
    const panel = drawer?.querySelector('.theme-drawer__dialog');
    if (!(drawer instanceof HTMLElement) || !(panel instanceof HTMLDialogElement)) return;

    if (typeof drawer.close === 'function') return;

    event.preventDefault();
    event.stopPropagation();
    if (panel.open) panel.close();
    drawer.removeAttribute('open');
  }, true);

  } catch(e) { console.error(e); }
})();
})();
